import { Link } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";

export const ActiveCampaign = styled(Link)`
  ${tw`border active:border-yellow-400 shadow mx-auto m-2 max-w-xs rounded-xl relative overflow-hidden`}
`;
